import React, { useRef, useState } from "react";
import { BsDownload } from "react-icons/bs";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
// import jsonData from './settlementReportData.json';
import { downloadSettlementReport } from "api/settlement";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import toast from "react-hot-toast";

// Import report functions
import summaryReportExcelSheets from "./settlementReportTypes/summary/summaryReports";
import cardTypeVisaReportsExcelSheets from "./settlementReportTypes/cards/CardTypeVisaReports";
import cardTypeDiscoverReportsExcelSheets from "./settlementReportTypes/cards/CardTypeDiscoverReports";
import cardTypeAmexReportsExcelSheets from "./settlementReportTypes/cards/CardTypeAmexReports";
import cardTypeMasterCardReportsExcelSheets from "./settlementReportTypes/cards/CardTypeMasterCardReports";
import refundReportExcelSheets from "./settlementReportTypes/refunded/refundReports";
import cancelReportExcelSheets from "./settlementReportTypes/canceled/cancelReports";
import declinedReportExcelSheets from "./settlementReportTypes/declined/declinedReports";
import disputeReportExcelSheets from "./settlementReportTypes/dispute/disputeReports";
import chargebackReportExcelSheets from "./settlementReportTypes/chargeback/chargebackReports";
import heldReportExcelSheets from "./settlementReportTypes/held/heldReports";
import erroredReportExcelSheets from "./settlementReportTypes/errored/erroredReports";
import { FaDownload } from "react-icons/fa";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader , PopoverArrow } from "@chakra-ui/react";
import { Portal } from '@chakra-ui/portal'

interface ClientTransactionData {
  settlementReportCanBeGenerated : boolean,
  excelData: any[],
}

function SettlementReport(props: {
  ReportData?: any;
  handleDownloadReport?: any;
  settlementInfo?: any;
  fetchAllsettlement?:any;

}) {
  const { ReportData, settlementInfo, handleDownloadReport ,fetchAllsettlement} = props;

  const [loadingDownload, setLoadingDownload] = useState(false);

  // const [jsonData, setJsonData] = useState([]);
  let jsonData: any = [];

  const createExcel = () => {
    try {
      let templateColor = {
        yellow: "b59a67",
        blue: "152046",
        black: "070708",
        white: "f5f5fc",
      };

      if (jsonData?.settlementReportCanBeGenerated) {
        const workbook = new ExcelJS.Workbook();

        summaryReportExcelSheets(jsonData, workbook, templateColor);
        cardTypeAmexReportsExcelSheets(jsonData, workbook, templateColor);
        cardTypeMasterCardReportsExcelSheets(jsonData, workbook, templateColor);
        cardTypeVisaReportsExcelSheets(jsonData, workbook, templateColor);
        cardTypeDiscoverReportsExcelSheets(jsonData, workbook, templateColor);
        refundReportExcelSheets(jsonData, workbook, templateColor);
        cancelReportExcelSheets(jsonData, workbook, templateColor);
        chargebackReportExcelSheets(jsonData, workbook, templateColor);
        disputeReportExcelSheets(jsonData, workbook, templateColor);
        heldReportExcelSheets(jsonData, workbook, templateColor);
        declinedReportExcelSheets(jsonData, workbook, templateColor);
        erroredReportExcelSheets(jsonData, workbook, templateColor);

        workbook.xlsx.writeBuffer().then((buffer: any) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, `Settlement Report.xlsx`);
        });
        fetchAllsettlement()
      } else {
        alert("Cannot create Excel.");
      }
    } catch (error) {
    }
  };

  const handleExcelData = () => {
    try {
      setLoadingDownload(true);
      downloadSettlementReport(settlementInfo?.row?.original?.id)
        .then((res: any) => {
          if (res?.settlementReportCanBeGenerated) {
            jsonData = res;
            createExcel();
          } else {
            toast.error("Oops! There are no transaction of clients for the organization in the selected date period.");
          }
        })
        .catch(() => {
          toast.error("Something went wrong.");
        })
        .finally(() => {
          setLoadingDownload(false);
        });
    } catch (error) {
    }
  };

  return (
    <div>
      {loadingDownload ? (
        <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
      ) : (
        <Popover trigger="hover" placement="bottom">
          <PopoverTrigger>
            <span onClick={handleExcelData}>
                <FaDownload
                  title="Download file"
                  className="h-5 w-5 cursor-pointer text-blue-500"
                />
              </span>
          </PopoverTrigger>  
          {/* <Portal >  */}
            <PopoverContent borderColor='blue.800' className="z-20 dark:bg-gray-800 shadow  invisible inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 dark:text-gray-400 dark:border-gray-600 dark:bg-gray-800 p-3 border-6 shadow !bg-gray-700">
              <PopoverHeader>
                <span className="text-sm  font-bold text-white">
              Download Settlement Report
              </span>
              </PopoverHeader>
              <PopoverArrow  className="border h-8 w-8 border-gray-700 !bg-gray-700  "  />
            </PopoverContent>
          {/* </Portal> */}
        </Popover>
      )}
    </div>
  );
}

export default SettlementReport;
